import { createReducer, on } from '@ngrx/store';
import * as AgencyConfigActions from './agencyConfig.action';
import { AgencyConfigInfo } from '../model/agencyConfig.model';

export interface AgencyConfigState {
  agencyConfig: AgencyConfigInfo | null;
  status: 'idle' | 'loading' | 'loaded' | 'failed';
  error?: string;
}

const initialState: AgencyConfigState = {
  agencyConfig: null,
  status: 'idle',
};

export const agencyConfigReducer = createReducer<
  AgencyConfigState,
  AgencyConfigActions.AgencyConfigTypes
>(
  initialState,
  on(AgencyConfigActions.getAgencyConfig, (state) => ({
    ...state,
    status: 'loading',
  })),
  on(AgencyConfigActions.getAgencyConfigSuccess, (state, { configInfo }) => ({
    ...state,
    agencyConfig: configInfo,
    status: 'loaded',
  })),
  on(AgencyConfigActions.getAgencyConfigFailed, (state, { error }) => ({
    ...state,
    error,
    status: 'failed',
  }))
);
